import React, { FC, PropsWithChildren } from "react";
import { View } from "@data-root/types";
import { DesktopNavigatorComponent } from "./desktop";
import { MobileNavigatorComponent } from "./mobile";
import { useClientContext } from "@data-root/react";

export interface MenuItem {
  key: string;
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
}

export interface NavigatorMasterProps {
  views: View[];

  headerLeftItems?: React.ReactNode[];
  headerCenterItems?: React.ReactNode[];
  headerRightItems?: React.ReactNode[];
  menu: MenuItem[];
}

export const Navigator: FC<PropsWithChildren<NavigatorMasterProps>> = (
  props
) => {
  const { desktop } = useClientContext();

  return desktop ? (
    <DesktopNavigatorComponent {...props} />
  ) : (
    <MobileNavigatorComponent {...props} />
  );
};
